module.exports = __webpack_public_path__ + "img/Open ticket icon.f825e908.png";